(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  if (motion.matches || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!motion.matches) entry.target.classList.add('datum-arrive');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08 });
  function observe(root) {
    root.querySelectorAll('.datum-wearer blockquote, .product-list .section-resource-list__header, .shopify-section .accordion').forEach(element => {
      if (element.getBoundingClientRect().top > innerHeight) observer.observe(element);
    });
  }
  observe(document);
  document.addEventListener('shopify:section:load', event => observe(event.target));
  motion.addEventListener('change', event => {
    if (event.matches) observer.disconnect();
  });
})();
document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('[data-datum-size-guide]');
  if (!link) return;
  const picker = link.closest('variant-picker');
  if (picker && document.getElementById(`DatumSize-${picker.dataset.sectionId}-${picker.dataset.blockId}`)) return;
  const details = document.getElementById(link.hash.slice(1));
  if (!(details instanceof HTMLDetailsElement)) return;
  event.preventDefault();
  details.open = true;
  details.querySelector('summary')?.focus({preventScroll:true});
  details.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
}, {capture:true});
